import React from "react";
import { Modal, BlockStack } from "@shopify/polaris";

function ApiAccessModal(props) {
  const {
    apiStatus,
    enableDisableApiLoading,
    handleApiOption,
    handleChange,
    isModalActive,
    selectedSellerBrandName,
    selectedSellerId,
    status,
  } = props;

  return (
    <>
      <Modal
        open={isModalActive}
        onClose={() => {
          handleChange();
        }}
        title="Disable API Confirmation"
        primaryAction={{
          content: "Confirm",
          onAction: () => handleApiOption(!!apiStatus.includes(status), selectedSellerId),
          loading: enableDisableApiLoading,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: () => {
              handleChange();
            },
          },
        ]}
      >
        <Modal.Section>
          <BlockStack gap="4">
            <p>
              Are you sure you want to disable the API for
              <b>{selectedSellerBrandName}</b>
            </p>
          </BlockStack>
        </Modal.Section>
      </Modal>
    </>
  );
}

export default ApiAccessModal;
